import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      logo: 'HIVE Gate',
      userInfo: 'User Info',
      address: 'Address',
      operationHours: 'Operation Hours',
      makeAnAppointment: 'Make an Appointment',
      fullName: 'Full Name',
      email: 'Email',
      company: 'Company',
      phone: 'Phone Number',
      appointmentType: 'Appointment Type',
      appointmentLength: 'Appointment Length',
      selectDesiredTime: 'Select Desired Time',
      appointmentDate: 'Appointment Date',
      availableTime: 'Available Time',
      submit: 'Submit',
      selectTypeAndDate: 'Please select appointment type and date to load available times',
      yourAppointment: 'Your Appointment -',
      appointmentTime: 'Appointment Date and Time',
      start: 'Start',
      end: 'End',
      cancelAppointment: 'Cancel Appointment',
      confirmCancellation: 'Confirm Cancellation',
      areYouSure: 'Are you sure you want to cancel your appointment?',
      yes: 'Yes',
      no: 'No',
      selectDifferentDate: 'No available times found. Please select a different date',
      refreshPage: 'Refresh Page',
      customerInfo: 'Customer Information',
      pageNotFound: 'Page Not Found',
      goBack: 'Go Back',
      missingUrlParams:
        'Could not load data: Request information is missing from the URL. Please copy the link you followed and contact your admin.',
    },
  },
  fr: {
    translation: {
      logo: 'Portail HIVE',
      userInfo: 'Informations Utilisateur',
      address: 'Adresse',
      operationHours: 'Heures de Fonctionnement',
      makeAnAppointment: 'Prendre Rendez-vous',
      fullName: 'Nom et Prénom',
      email: 'Email',
      company: 'Entreprise',
      phone: 'Numéro de Téléphone',
      appointmentType: 'Type de Rendez-vous',
      appointmentLength: 'Durée du Rendez-vous',
      selectDesiredTime: "Sélectionnez l'heure souhaitée",
      appointmentDate: 'Date de rendez-vous',
      availableTime: 'Temps disponible',
      submit: 'Soumettre',
      selectTypeAndDate:
        'Veuillez sélectionner le type de rendez-vous et la date pour charger les heures disponibles',
      yourAppointment: 'Votre Rendez-vous -',
      appointmentTime: 'Date et Heure du Rendez-vous',
      start: 'Début',
      end: 'Fin',
      cancelAppointment: 'Annuler Rendez-vous',
      confirmCancellation: "Confirmer L'annulation",
      areYouSure: 'Êtes-vous sûr de vouloir annuler votre rendez-vous?',
      yes: 'Oui',
      no: 'Non',
      selectDifferentDate: 'Aucune heure disponible trouvée. Veuillez sélectionner une autre date',
      refreshPage: 'Rafraîchir la Page',
      customerInfo: 'Informations client',
      pageNotFound: 'Page Non Trouvée',
      goBack: 'Retourner',
      missingUrlParams:
        "Impossible de charger les données : les informations de la demande sont manquantes dans l'URL. Veuillez copier le lien que vous avez suivi et contacter votre administrateur.",
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
})

export default i18n
